import * as Types from '../../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEmployeeBudgetsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetEmployeeBudgetsQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: string, holidayCost?: number | null, budgets: Array<{ __typename?: 'EmployeeBudget', balance: number, budget: { __typename?: 'Budget', id: string, code: Types.BudgetCode, cashoutPaymentOptions?: { __typename?: 'CashoutPaymentOptions', cashOutPaymentType: string } | null, choiceCycle: { __typename?: 'ChoiceCycle', start?: any | null, end?: any | null, status: Types.BudgetStatus }, name: { __typename?: 'LocalizedText', en: string, fr?: string | null, nl?: string | null }, activationStatus: { __typename?: 'BudgetActivationStatus', active: boolean } }, topUpOrders: Array<{ __typename?: 'TopUpOrder', expectedAmount: number, fulfilled: boolean, date: any, id: string, label?: string | null }>, cashOutOrders: Array<{ __typename?: 'CashOutOrder', expectedAmount?: number | null, date: any, fulfilled: boolean, id: string, tags: Array<string> }>, paymentOrders: Array<{ __typename?: 'PaymentOrder', id: string, expectedAmount: number, dueDate: any, fulfilled: boolean, committed: boolean, choice: { __typename?: 'Choice', id: string, product: { __typename?: 'Product', id: string, name: string, image: string } } }> }> } };

export type GetBudgetTransactionsQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  budgetId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetBudgetTransactionsQuery = { __typename?: 'Query', transactions: Array<{ __typename?: 'Transaction', id: string, amount: number, createdAt: any, status: Types.TransactionStatusType, tags: Array<string>, holidayCost?: number | null, budget: { __typename?: 'Budget', id: string, code: Types.BudgetCode, name: { __typename?: 'LocalizedText', en: string, fr?: string | null, nl?: string | null } }, choice?: { __typename?: 'Choice', id: string, product: { __typename?: 'Product', id: string, image: string, name: string } } | null }> };


export const GetEmployeeBudgetsDocument = gql`
    query GetEmployeeBudgets {
  employee {
    id
    budgets {
      balance
      budget {
        cashoutPaymentOptions {
          cashOutPaymentType
        }
        choiceCycle {
          start
          end
          status
        }
        id
        code
        name {
          en
          fr
          nl
        }
        activationStatus {
          active
        }
      }
      topUpOrders {
        expectedAmount
        fulfilled
        date
        id
        label
      }
      cashOutOrders {
        expectedAmount
        date
        fulfilled
        id
        tags
      }
      paymentOrders {
        id
        expectedAmount
        dueDate
        fulfilled
        committed
        choice {
          id
          product {
            id
            name
            image
          }
        }
      }
    }
    holidayCost
  }
}
    `;

/**
 * __useGetEmployeeBudgetsQuery__
 *
 * To run a query within a React component, call `useGetEmployeeBudgetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeBudgetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeBudgetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeeBudgetsQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeeBudgetsQuery, GetEmployeeBudgetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeBudgetsQuery, GetEmployeeBudgetsQueryVariables>(GetEmployeeBudgetsDocument, options);
      }
export function useGetEmployeeBudgetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeBudgetsQuery, GetEmployeeBudgetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeBudgetsQuery, GetEmployeeBudgetsQueryVariables>(GetEmployeeBudgetsDocument, options);
        }
export function useGetEmployeeBudgetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeeBudgetsQuery, GetEmployeeBudgetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeeBudgetsQuery, GetEmployeeBudgetsQueryVariables>(GetEmployeeBudgetsDocument, options);
        }
export type GetEmployeeBudgetsQueryHookResult = ReturnType<typeof useGetEmployeeBudgetsQuery>;
export type GetEmployeeBudgetsLazyQueryHookResult = ReturnType<typeof useGetEmployeeBudgetsLazyQuery>;
export type GetEmployeeBudgetsSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeBudgetsSuspenseQuery>;
export type GetEmployeeBudgetsQueryResult = Apollo.QueryResult<GetEmployeeBudgetsQuery, GetEmployeeBudgetsQueryVariables>;
export const GetBudgetTransactionsDocument = gql`
    query GetBudgetTransactions($limit: Int, $budgetId: ID) {
  transactions(limit: $limit, budgetId: $budgetId, statuses: [CONFIRMED, PENDING]) {
    id
    amount
    createdAt
    status
    tags
    budget {
      id
      code
      name {
        en
        fr
        nl
      }
    }
    choice {
      id
      product {
        id
        image
        name
      }
    }
    holidayCost
  }
}
    `;

/**
 * __useGetBudgetTransactionsQuery__
 *
 * To run a query within a React component, call `useGetBudgetTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBudgetTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBudgetTransactionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      budgetId: // value for 'budgetId'
 *   },
 * });
 */
export function useGetBudgetTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetBudgetTransactionsQuery, GetBudgetTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBudgetTransactionsQuery, GetBudgetTransactionsQueryVariables>(GetBudgetTransactionsDocument, options);
      }
export function useGetBudgetTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBudgetTransactionsQuery, GetBudgetTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBudgetTransactionsQuery, GetBudgetTransactionsQueryVariables>(GetBudgetTransactionsDocument, options);
        }
export function useGetBudgetTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBudgetTransactionsQuery, GetBudgetTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBudgetTransactionsQuery, GetBudgetTransactionsQueryVariables>(GetBudgetTransactionsDocument, options);
        }
export type GetBudgetTransactionsQueryHookResult = ReturnType<typeof useGetBudgetTransactionsQuery>;
export type GetBudgetTransactionsLazyQueryHookResult = ReturnType<typeof useGetBudgetTransactionsLazyQuery>;
export type GetBudgetTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetBudgetTransactionsSuspenseQuery>;
export type GetBudgetTransactionsQueryResult = Apollo.QueryResult<GetBudgetTransactionsQuery, GetBudgetTransactionsQueryVariables>;